<ng-container *ngIf="permConfig.isAddAllowed">
    <div class="container-fluid">
        <app-page-title title="Add Pickup"></app-page-title>
        <form [formGroup]="pickupForm">
            <div class="row">
                <div class="col-12">
                    <div class="card">
                        <div class="card-body">
                            <div class="row">
                                <div class="col-md-2">
                                    <div class="mb-2">
                                        <label for="customer" class="form-label">Customer </label>
                                        <ng-select id="customer" placeholder="Select" [items]="customerList" 
                                            [appendTo]="'body'" [openOnEnter]="false" formControlName="ddlCustomer" bindLabel="name" [bindValue]="'id'" 
                                            class="ng-select ng-select-single ng-select-searchable ng-select-clearable ng-select-bottom"
                                            (keydown.enter)="useEnterKey && pickupDate.focus()"
                                            (change)="bindCustomerShipperInfo()">
                                        </ng-select>

                                    </div>
                                </div>
                                <div class="col-md-2">
                                    <div class="mb-2">
                                      <label for="pickupDate" class="form-label">Pickup Date</label><span class="mandatory">*</span>
                                      <input #pickupDate type="datetime-local" class="form-control form-control-sm" formControlName="txtDateTime" id="pickupDate" 
                                        [min]="minDateTime" max="3000-12-31T23:59"
                                        [ngClass]="{'is-invalid': (isFormSubmitted || pickupForm.get('txtDateTime')?.touched) && pickupForm.get('txtDateTime').errors}"
                                        (keydown.enter)="useEnterKey && pickupForm.get('txtDateTime').valid ? this.appShipperAddress.focusFirstField() : pickupForm.get('txtDateTime').markAsTouched()" />
                                      <div *ngIf="(isFormSubmitted || pickupForm.get('txtDateTime')?.touched) && pickupForm.get('txtDateTime').errors"
                                        class="invalid-feedback">
                                        <span *ngIf="pickupForm.get('txtDateTime').errors.minDate">Invalid date format</span>
                                        <span *ngIf="pickupForm.get('txtDateTime').errors.required">Pickup date is required</span>
                                      </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-md-6">
                    <div class="card">
                        <div class="card-header bg-transparent border-bottom text-uppercase">
                            SHIPPER
                        </div>
                        <div class="card-body">
                            <div class="row">
                                <app-address #appShipperAddress formGroupName="shipperlocationdetails" [formSubmitted]="isFormSubmitted"
                                    [listType]="'origin'" [address]="shipperLocationInfo" 
                                    [countryList] = "countryList"
                                    (addressBookListEmit)="getAddressbookList($event)" (byLocationChange)="isShipperCustomerBinded = false"
                                    (getAddress)="getOriginLocation($event)" 
                                    (focusEmit)="appConsigneeAddress.focusFirstField()">
                                </app-address>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="col-md-6">
                    <div class="card">
                        <div class="row">
                            <div class="card-header bg-transparent border-bottom text-uppercase col-md-6">
                                CONSIGNEE
                            </div>
                            <div class="col-md-6 d-flex justify-content-end">
                                <span title="Reset" (click)="resetConsigneeForm()"><i
                                        class="mdi mdi-sync font-size-22 action-group"></i></span>
                            </div>
                        </div>
                        <div class="card-body">
                            <div class="row">
                                <app-address #appConsigneeAddress formGroupName="consigneelocationdetails" [formSubmitted]="isFormSubmitted"
                                    [listType]="'destination'" [address]="consigneeLocationInfo" (addressBookListEmit)="getAddressbookList($event)"
                                    [countryList] = "countryList" (getAddress)="getDestinationLocation($event)"
                                    [focusConsigneeName]="focusConsigneeName"
                                    (focusEmit)="servicecenter.focus()">
                                </app-address>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="row">
                <div class="col-12">
                    <div class="card flex-grow-1">
                        <div class="card-header bg-transparent border-bottom text-uppercase">
                            ADDITIONAL INFO
                        </div>
                        <div class="card-body">
                            <div class="row">
                                <div class="col-md-2">
                                    <label for="servicecenter" class="form-label">Service Center </label>
                                    <ng-select #servicecenter id="servicecenter" placeholder="Select" [items]="ServiceCenterOptions"
                                        [appendTo]="'body'" [openOnEnter]="false" formControlName="txtServiceCenter" bindLabel="name"
                                        [bindValue]="'id'"
                                        class="ng-select ng-select-single ng-select-searchable ng-select-clearable ng-select-bottom"
                                        (keydown.enter)="useEnterKey && pickupForm.get('txtServiceCenter').valid ? status.focus() : pickupForm.get('txtServiceCenter').markAsTouched()">
                                    </ng-select>
                                </div>
                                <div class="col-md-2">
                                    <div class="mb-2">
                                        <label for="status" class="form-label">Status</label>
                                        <ng-select #status formControlName="ddlStatus" placeholder="Select"
                                            [items]="statusType" [appendTo]="'body'" [openOnEnter]="false" (change)="onChangeStatus()"
                                            (keydown.enter)="useEnterKey && pickupForm.get('ddlStatus').valid ? manageStatusChangeFocus() : pickupForm.get('ddlStatus').markAsTouched()">
                                        </ng-select>
                                    </div>
                                </div>
                                <div class="col-md-2" *ngIf="assignedStatus">
                                    <div class="mb-2">
                                        <label for="fieldExecutive" class="form-label">Field Executive<span *ngIf="assignedStatus" class="mandatory">*</span></label>
                                        <ng-select #fieldExecutiveRef id="fieldExecutive" formControlName="ddlFieldExecutive"
                                            placeholder="Select" [items]="fieldExecutiveList" [appendTo]="'body'" [openOnEnter]="false"
                                            bindLabel="username" [bindValue]="'id'"
                                            class="ng-select ng-select-single ng-select-searchable ng-select-clearable ng-select-bottom"
                                            [ngClass]="{'is-invalid': (isFormSubmitted || pickupForm.get('ddlFieldExecutive').touched) && pickupForm.get('ddlFieldExecutive').errors}"
                                            (keydown.enter)="useEnterKey && pickupForm.get('ddlFieldExecutive').valid ? salesExecutiveRef.focus() : pickupForm.get('ddlFieldExecutive').markAsTouched()" >
                                        </ng-select>
                                        <div *ngIf="pickupForm.get('ddlFieldExecutive').errors" class="invalid-feedback">
                                            <span *ngIf="pickupForm.get('ddlFieldExecutive').errors.required">Field Executive is required</span>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-2">
                                    <div class="mb-2">
                                        <label for="salesExecutive" class="form-label">Sales Executive </label>
                                        <ng-select #salesExecutiveRef id="salesexecutive" formControlName="ddlSalesExecutive"
                                            placeholder="Select" [items]="salesExecutiveList" [appendTo]="'body'" [openOnEnter]="false"
                                            bindLabel="username" [bindValue]="'id'"
                                            class="ng-select ng-select-single ng-select-searchable ng-select-clearable ng-select-bottom" 
                                            (keydown.enter)="useEnterKey && vehicletype.focus()">
                                        </ng-select>
                                    </div>
                                </div>
                                <div class="col-md-2">
                                    <div class="mb-2">
                                    <label for="vehicletype" class="form-label">Vehicle Type </label>
                                    <ng-select #vehicletype id="vehicletype" placeholder="Select" [items]="vehicleTypes"
                                        [appendTo]="'body'" [openOnEnter]="false" formControlName="ddlVehicleTypes"
                                        class="ng-select ng-select-single ng-select-searchable ng-select-clearable ng-select-bottom"
                                        (keydown.enter)="useEnterKey && specialInstructions.focus()">
                                    </ng-select>
                                    </div>
                                </div>
                                <div class="col-md-4">
                                    <div class="mb-2">
                                        <label for="specialInstructions" class="form-label">Special Instructions</label>
                                        <input #specialInstructions type="text" class="form-control form-control-sm" id="specialInstructions"
                                            formControlName="txtSpecialInstructions" maxlength="150"
                                            (keydown.enter)="useEnterKey && submitBtn.focus()">
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="row">
                <div class="col-12">
                    <div class="button-items">
                        <button #submitBtn type="button" class="btn btn-primary w-sm" (click)="addPickup()" (keydown.enter)="addPickup()">Add</button>
                        <a routerLink="/operation/pickups"><button type="button"
                                class="btn btn-secondary w-sm">Cancel</button></a>
                    </div>
                </div>
            </div>
        </form>
    </div>
</ng-container>

<ng-container *ngIf="!permConfig.isAddAllowed">
    <app-forbidden></app-forbidden>
</ng-container>